var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "dashboard", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "dashContent judgeView" },
        [
          _vm.resource
            ? _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Status", "label-cols-md": "2" } },
                    [
                      _c(
                        "b-form-select",
                        {
                          on: { change: _vm.doFilter },
                          model: {
                            value: _vm.filter.mregType,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "mregType", $$v)
                            },
                            expression: "filter.mregType",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: null, disabled: "" } },
                            [_vm._v("-- Please select an option --")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "MB" } },
                            [_vm._v("Ballot")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "FR" } },
                            [_vm._v("Fast Runner")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-pagination-nav", {
                    attrs: {
                      "number-of-pages": _vm.maxPage,
                      "base-url": "/list/",
                      "last-number": "",
                      "use-router": _vm.useRouter,
                      align: "fill",
                      limit: "10",
                      "link-gen": _vm.linkGen,
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      items: _vm.resource.data,
                      fields: _vm.fields,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(zmemFullName)",
                          fn: function (row) {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "adminListName",
                                  attrs: { size: "md" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.show(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(row.detailsShowing ? "👁" : "👤") +
                                      " " +
                                      _vm._s(row.item.zmemFullName) +
                                      "\n\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(mbsdEmail)",
                          fn: function (row) {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "adminListName",
                                  attrs: { size: "md" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.mailTo(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(row.item.mbsdEmail) +
                                      "\n\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "row-details",
                          fn: function (row) {
                            return [
                              row.item.detail
                                ? _c(
                                    "div",
                                    [
                                      row.item.mbsdStatus == 0
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass: "mb-3",
                                              attrs: {
                                                block: "",
                                                variant: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.verifyData(row)
                                                },
                                              },
                                            },
                                            [_vm._v("Approve Data")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      row.item.mbsdStatus == 0
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass: "mb-3",
                                              attrs: {
                                                block: "",
                                                variant: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updateProfile(row)
                                                },
                                              },
                                            },
                                            [_vm._v("Reject Data")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        row.item.detail.linked,
                                        function (l, f) {
                                          return _c(
                                            "b-card",
                                            { key: f, attrs: { data: l } },
                                            [
                                              f == "mregZmemId"
                                                ? _c("b-card-title", [
                                                    _vm._v("Transaction Info"),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              f == "mmedZmemId"
                                                ? _c("b-card-title", [
                                                    _vm._v("Additional Info"),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              f == "mbsdZmemId"
                                                ? _c("b-card-title", [
                                                    _vm._v("Member Info"),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              f == "mbspZmemId"
                                                ? _c("b-card-title", [
                                                    _vm._v("Phone Info"),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._l(
                                                l[0],
                                                function (value, key) {
                                                  return _c(
                                                    "b-row",
                                                    {
                                                      key: key,
                                                      staticClass: "mb-2",
                                                      attrs: { data: value },
                                                    },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "text-sm-right",
                                                          attrs: { sm: "5" },
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(_vm._s(key)),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b-col", [
                                                        _vm._v(_vm._s(value)),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              row.item.mregType == "FR" &&
                                              f == "mregZmemId" &&
                                              l[0] &&
                                              l[0].mregStatus == 0
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        block: "",
                                                        variant: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.approveBallot(
                                                            l[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Approve Fast Runner"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              row.item.mregType == "FR" &&
                                              f == "mregZmemId" &&
                                              l[0] &&
                                              l[0].mregStatus == 0
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        block: "",
                                                        variant: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.rejectFastRunner(
                                                            l[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Reject Fast Runner"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "cell(mbsdFile)",
                          fn: function (data) {
                            return [
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "8px",
                                    "letter-spacing": "2px",
                                    "text-transform": "uppercase",
                                    display: "block",
                                  },
                                  attrs: {
                                    target: "_blank",
                                    href:
                                      "https://private.borobudurmarathon.com/view/" +
                                      `${data.value}`,
                                  },
                                },
                                [_vm._v(_vm._s(data.value))]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href:
                                      "https://private.borobudurmarathon.com/view/" +
                                      `${data.value}`,
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: { "max-width": "250px" },
                                    attrs: {
                                      src:
                                        "https://private.borobudurmarathon.com/view/" +
                                        `${data.value}`,
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3967655652
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/FastRunnerTableView.vue